import { getActiveRegion } from '@4cm/core/i18n';
import type { RegionPack } from '@4cm/core/i18n/types';

/**
 * Region pack hook for web2. v1 launches in the UK so this returns the
 * UK pack on every render — UK is the source of truth for terms,
 * units, governance refs, and age-phase labels.
 *
 * Coach-visible copy must read from `useRegion().terms.*` (or the
 * region-aware formatters in `lib/i18n/format.ts` once those land)
 * rather than hard-coding "field" / "game" / "kit" — see AGENTS.md.
 *
 * The shape mirrors apps/web's hook so a future swap to a dynamic
 * source (org.country, coach setting) is a one-line change.
 */
export function useRegion(): RegionPack {
  return getActiveRegion();
}
